export default {
  SET_employees(state, payload) {
    state.employees = payload
  },
  SET_birthdays(state, payload) {
    state.birthdays = payload
  },
}
